import { Breadcrumb } from "~/models/breadcrumb";
import { Logger } from "~/utils/logger";
const logger = new Logger("breadcrumbs", "info");

/**
 * Implement a bread crumbs component.
 */
export function Breadcrumbs({ crumbs }: { crumbs: Breadcrumb[] | undefined }) {
  const lastCrumb = crumbs?.pop();

  logger.debug("lastCrumb:", lastCrumb);
  logger.debug("remaining crumbs:", crumbs);

  return (
    <div className="cn-container-class">
      <div className="tw:hidden tw:md:flex tw:md:flex-row tw:flex-wrap tw:text-[#001936] tw:text-md">
        {crumbs?.map((crumb) => (
          <div key={crumb.url}>
            <a className="tw:underline!" href={crumb.url}>
              {crumb.title}
            </a>
            &nbsp;/&nbsp;
          </div>
        ))}

        {/* last crumb is current page, don't make it a link */}
        <div>{lastCrumb?.title}</div>
      </div>
    </div>
  );
}
